<p-fieldset [style]="{ 'padding': '1rem !important' }">
  <ng-template #header>
    <span style="font-size: 0.75rem !important">{{ labelText }}</span>
  </ng-template>
  <div class="grid w-full">
    <div class="col-11 align-items-center">
      <p-chip *ngFor="let user of addressList" [removable]="true" class="x-small" (onRemove)="chipRemove(user)">
        <img [src]="user | userImage | async" alt="User Image" style="height: 1.5rem; width: 1.5rem; border-radius: 0.75rem" />
        <span>{{ user | userDisplayName | async }}</span>
      </p-chip>
    </div>
    <div class="col justify-content-end align-items-center" style="width: 25px">
      <button
        pButton
        pRipple
        type="button"
        icon="fa fa-search"
        text
        rounded
        severity="secondary"
        [outlined]="true"
        (click)="dlgShow()"
        data-testid="dlgAddressBook"
        [disabled]="disable"></button>
    </div>
  </div>
</p-fieldset>

<ng-container *ngIf="this.dlgVars.visible">
  <p-dialog
    [modal]="true"
    [showHeader]="false"
    [position]="'center'"
    [closeOnEscape]="true"
    [closable]="false"
    [(visible)]="dlgVars.visible"
    [style]="{ 'width': '50rem' }"
    appendTo="body">
    <ng-template pTemplate="header"> Address Book </ng-template>
    <div>
      <p-table
        #dt
        [value]="filteredAddressBook"
        dataKey="email"
        [scrollable]="true"
        scrollHeight="50vh"
        selectionMode="multiple"
        [(selection)]="selectedUsers"
        [globalFilterFields]="['displayName', 'email']"
        [tableStyle]="{ 'width': '100%' }">
        <ng-template #caption>
          <p-iconfield iconPosition="left" class="ml-auto">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input
              #searchBox
              pInputText
              type="text"
              (input)="dt.filterGlobal(searchBox.value, 'contains')"
              placeholder="Search keyword"
              class="w-full"
              [style]="{ 'font-size': '0.75rem' }" />
          </p-iconfield>
        </ng-template>
        <ng-template #header>
          <tr>
            <th></th>
            <th style="width: 4rem"></th>
            <th>Display Name</th>
            <th>Email</th>
            <th style="width: 4rem"></th>
          </tr>
        </ng-template>
        <ng-template #body let-item let-rowIndex="rowIdx">
          <tr [pSelectableRow]="item">
            <td></td>
            <td style="width: 4rem"><img [src]="item.email | userImage | async" style="height: 1.5rem; width: 1.5rem; border-radius: 0.75rem" /></td>
            <td style="font-size: 0.85rem">
              {{ item.displayName }}
            </td>
            <td style="font-size: 0.85rem">
              {{ item.email }}
            </td>
            <td style="width: 4rem">
              <button
                pButton
                pRipple
                type="button"
                icon="fa fa-circle-info"
                text
                rounded
                severity="primary"
                [outlined]="true"
                (click)="infoShow(item)"
                data-testid="userInfo"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <ng-template pTemplate="footer" class="flex justify-content-between gap-2 mt-2">
      <ng-container>
        <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
          <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="dlgCancel()" data-testid="dlgCancel" />
          <p-button
            label="Select"
            icon="fa fa-check"
            severity="success"
            size="small"
            [raised]="true"
            (click)="dlgSelect()"
            [disabled]="selectedUsers.length === 0"
            data-testid="dlgSelect" />
        </div>
      </ng-container>
    </ng-template>
  </p-dialog>
</ng-container>

<ng-container *ngIf="this.infoVars.visible && this.infoVars.user">
  <p-dialog
    #info
    [modal]="true"
    [showHeader]="false"
    [position]="'center'"
    [closeOnEscape]="true"
    [closable]="false"
    [(visible)]="infoVars.visible"
    [style]=""
    appendTo="body">
    <ng-template pTemplate="header">
      <div class="grid">
        <div class="col-4">
          <img [src]="infoVars.user.email | userImage | async" style="height: 5rem; width: 5rem; border-radius: 2.5rem" />
        </div>
        <div class="col-6">
          <div class="flex flex-column ml-2 justify-items-center">
            <div style="font-size: 2rem; margin-bottom: 0.75rem; margin-top: 0.75rem">
              {{ infoVars.info.givenName }}
            </div>
            <div style="font-size: 2rem">
              {{ infoVars.info.surname }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <div>
      <p-fieldset legend="Business Phone(s)">
        <span *ngIf="infoVars.info.businessPhones.length === 0"> None </span>
        <span *ngFor="let phone of infoVars.info.businessPhones">
          {{ phone }}
        </span>
      </p-fieldset>
      <p-fieldset legend="Email">
        {{ infoVars.info.mail }}
      </p-fieldset>
    </div>
    <ng-template pTemplate="footer" class="flex justify-content-between gap-2 mt-2">
      <ng-container>
        <div class="border-top-1 surface-border pt-2 flex justify-content-end w-full">
          <p-button label="Close" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="infoHide()" data-testid="infoHide" />
        </div>
      </ng-container>
    </ng-template>
  </p-dialog>
</ng-container>
